/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nda_Login_RequiredInputs */



/**
* | output |
* | --- |
* | "Sign in to view your NDA signature request." |
*
* @param {Nda_Login_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_login_required = /** @type {((inputs?: Nda_Login_RequiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Login_RequiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connectez-vous pour voir votre demande de signature de NDA.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inicie sesión para ver su solicitud de firma del NDA.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Entre para ver sua solicitação de assinatura do NDA.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accedi per vedere la tua richiesta di firma dell'NDA.")
	return /** @type {LocalizedString} */ ("Sign in to view your NDA signature request.")
});